'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resizeObserver = undefined;
exports.arrowObserver = arrowObserver;
exports.dotObserver = dotObserver;
exports.keyObserver = keyObserver;
exports.transitionEndObserver = transitionEndObserver;
exports.touchObserver = touchObserver;
exports.autoPlayObserver = autoPlayObserver;

var _Observable = require('rxjs/Observable');

var _Subject = require('rxjs/Subject');

require('rxjs/add/observable/fromEvent');

require('rxjs/add/observable/of');

require('rxjs/add/observable/fromEventPattern');

require('rxjs/add/observable/merge');

require('rxjs/add/observable/interval');

require('rxjs/add/observable/never');

require('rxjs/add/operator/mergeMap');

require('rxjs/add/operator/mapTo');

require('rxjs/add/operator/map');

require('rxjs/add/operator/filter');

require('rxjs/add/operator/takeUntil');

require('rxjs/add/operator/delay');

require('rxjs/add/operator/timeInterval');

require('rxjs/add/operator/switchMap');

require('rxjs/add/operator/debounceTime');

var swipeDown = void 0,
    swipeMove = void 0,
    swipeUp = void 0;

function setupSwipeObservables(elements) {
    if (!swipeDown) {
        swipeDown = _Observable.Observable.merge(_Observable.Observable.fromEvent(elements.viewport, 'mousedown'), _Observable.Observable.fromEvent(elements.viewport, 'touchstart'));
    }

    if (!swipeMove) {
        swipeMove = _Observable.Observable.merge(_Observable.Observable.fromEvent(elements.viewport, 'mousemove'), _Observable.Observable.fromEvent(elements.viewport, 'touchmove'));
    }

    if (!swipeUp) {
        var cancel = _Observable.Observable.merge(_Observable.Observable.fromEvent(elements.viewport, 'mouseleave'), _Observable.Observable.fromEvent(elements.viewport, 'touchcancel'));

        var up = _Observable.Observable.merge(_Observable.Observable.fromEvent(elements.viewport, 'mouseup'), _Observable.Observable.fromEvent(elements.viewport, 'touchend'));

        swipeUp = _Observable.Observable.merge(cancel, up);
    }
}

function arrowObserver(elements) {
    if (!elements.nextArrow && !elements.prevArrow) {
        return _Observable.Observable.of(0);
    }

    var nextOb = _Observable.Observable.fromEvent(elements.nextArrow, 'click').mapTo(1);

    var prevOb = _Observable.Observable.fromEvent(elements.prevArrow, 'click').mapTo(-1);

    return _Observable.Observable.merge(nextOb, prevOb);
}

function dotObserver(elements, dotClass) {
    if (!elements.dotNav) {
        return;
    }

    var handleClicks = function handleClicks(handler) {
        return function (evt) {
            if (evt.target.classList.contains(dotClass)) {
                handler(evt);
            }
        };
    };

    return _Observable.Observable.merge(_Observable.Observable.fromEventPattern(function (handler) {
        return elements.dotNav.addEventListener('click', handleClicks(handler));
    }, function (handler) {
        return elements.dotNav.removeEventListener('click', handleClicks(handler));
    }), _Observable.Observable.fromEventPattern(function (handler) {
        return elements.dotNav.addEventListener('touchend', handleClicks(handler));
    }, function (handler) {
        return elements.dotNav.removeEventListener('touchend', handleClicks(handler));
    })).map(function (evt) {
        return evt.target.dataset.index;
    }).map(function (index) {
        return parseInt(index);
    });
}

function keyObserver(elements) {
    if (!elements.slider) {
        return;
    }

    var keyCodes = ['ArrowLeft', 'ArrowRight'];

    return _Observable.Observable.fromEvent(document, 'keyup').filter(function (evt) {
        return ~keyCodes.indexOf(evt.code);
    }).map(function (evt) {
        return evt.code === 'ArrowLeft' ? -1 : 1;
    });
}

function transitionEndObserver(elements) {
    return _Observable.Observable.merge(_Observable.Observable.fromEvent(elements.track, 'webkitTransitionEnd'), _Observable.Observable.fromEvent(elements.track, 'transitionend'), _Observable.Observable.fromEvent(elements.track, 'msTransitionEnd'), _Observable.Observable.fromEvent(elements.track, 'oTransitionEnd'));
}

function touchObserver(elements) {
    setupSwipeObservables(elements);

    var mouseDrag = swipeDown.mergeMap(function (mouseDownEvt) {
        var mouseDownPos = null;
        if (~mouseDownEvt.type.indexOf('touch')) {
            mouseDownPos = mouseDownEvt.touches[0];
        } else {
            mouseDownPos = mouseDownEvt;
        }

        return swipeMove.map(function (evt) {
            var pos = null;
            if (~evt.type.indexOf('touch')) {
                pos = evt.touches[0];
            } else {
                pos = evt;
            }
            return {
                left: pos.clientX - mouseDownPos.clientX,
                top: pos.clientY - mouseDownPos.clientY
            };
        }).takeUntil(swipeUp);
    });

    return _Observable.Observable.merge(swipeDown.mapTo('down'), mouseDrag, swipeUp.mapTo('up'), swipeUp.delay(1).mapTo('end'));
}

function autoPlayObserver(elements, options, cb) {
    var interval = _Observable.Observable.interval(options.autoplaySpeed).timeInterval().mapTo(1);

    var pauser = new _Subject.Subject();

    pauser.switchMap(function (paused) {
        return paused ? _Observable.Observable.never() : interval;
    }).subscribe(function (x) {
        return cb(x);
    });

    pauser.next(false);

    if (options.pauseOnDots && options.dots) {
        dotPauser(elements, pauser);
    }

    if (options.pauseOnArrows && options.arrows) {
        arrowPauser(elements, pauser);
    }

    if (options.swipe) {
        swipePauser(elements, pauser);
    }

    return {
        pause: function pause() {
            return pauser.next(true);
        },
        play: function play() {
            return pauser.next(false);
        }
    };
}

function dotPauser(elements, pauser) {
    _Observable.Observable.merge(_Observable.Observable.fromEvent(elements.dotNav, 'mouseenter').mapTo(true), _Observable.Observable.fromEvent(elements.dotNav, 'mouseleave').mapTo(false)).subscribe(function (pause) {
        return pauser.next(pause);
    });
}

function arrowPauser(elements, pauser) {
    _Observable.Observable.merge(_Observable.Observable.fromEvent(elements.nextArrow, 'mouseenter').mapTo(true), _Observable.Observable.fromEvent(elements.nextArrow, 'mouseleave').mapTo(false), _Observable.Observable.fromEvent(elements.prevArrow, 'mouseenter').mapTo(true), _Observable.Observable.fromEvent(elements.prevArrow, 'mouseleave').mapTo(false)).subscribe(function (pause) {
        return pauser.next(pause);
    });
}

function swipePauser(elements, pauser) {
    setupSwipeObservables(elements);

    var mouseDrag = swipeDown.mergeMap(function () {
        return swipeMove.takeUntil(swipeUp);
    });

    _Observable.Observable.merge(mouseDrag.mapTo(true), swipeUp.mapTo(false)).subscribe(function (pause) {
        return pauser.next(pause);
    });
}

var resizeObserver = exports.resizeObserver = function resizeObserver() {
    return _Observable.Observable.fromEvent(window, 'resize').debounceTime(500);
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/slider/events.js
// module id = ./resources/assets/js/src/slider/events.js
// module chunks = 0